export enum ScheduleRank {
  Unscheduled = 1,
  Scheduled = 2,
  Alternate = 3,
}
